// extracted by mini-css-extract-plugin
module.exports = {"close--Icon":"close--Icon__1Mm6d"};